import { authApi } from './authApi';
import { SystemCreate, SystemUpdate, SystemResponse, SystemDetailResponse } from '../types/system';

// GET /systems/
export const getSystems = async (): Promise<SystemResponse[]> => {
  const response = await authApi.get<SystemResponse[]>('/systems/');
  return response.data;
};

// GET /systems/{id}/
export const getSystem = async (systemId: string): Promise<SystemDetailResponse> => {
  const response = await authApi.get<SystemDetailResponse>(`/systems/${systemId}/`);
  return response.data;
};

// POST /systems/
export const createSystem = async (
  systemData: SystemCreate
): Promise<SystemResponse> => {
  const formData = new FormData();
  formData.append('name', systemData.name);
  formData.append('description', systemData.description || '');
  formData.append('base_url', systemData.base_url);

  if (systemData.logo) {
    formData.append('logo', systemData.logo, systemData.logo.name);
  }

  const response = await authApi.post<SystemResponse>('/systems/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// PUT /systems/{id}/
export const updateSystem = async (
  systemId: string,
  systemData: SystemUpdate
): Promise<SystemResponse> => {
  const formData = new FormData();
  if (systemData.name !== undefined) formData.append('name', systemData.name);
  if (systemData.description !== undefined) formData.append('description', systemData.description);
  if (systemData.base_url !== undefined) formData.append('base_url', systemData.base_url);

  if (systemData.logo) {
    formData.append('logo', systemData.logo, systemData.logo.name);
  }

  const response = await authApi.put<SystemResponse>(`/systems/${systemId}/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// DELETE /systems/{id}/
export const deleteSystem = async (systemId: string): Promise<{ detail: string }> => {
  const response = await authApi.delete<{ detail: string }>(`/systems/${systemId}/`);
  return response.data;
};
